// Page-to-Page Animation Transitions
// Coordinates smooth entry/exit page states using GSAP and native View Transitions.

document.addEventListener('DOMContentLoaded', () => {
  const gsap = window.gsap;

  // --- Recover from a leftover exit-transition state on Back/Forward navigation ---
  // When navigating away we cover the page with .theme-transition-overlay and fade
  // out #MainContent. If the browser restores this page from the back/forward cache
  // (bfcache), DOMContentLoaded does NOT fire again, so that covered state would
  // remain and the page looks blank. pageshow (persisted) lets us undo it.
  const resetTransitionState = () => {
    document.querySelectorAll('.theme-transition-overlay').forEach((el) => el.remove());

    const main = document.querySelector('#MainContent');
    if (main) {
      main.style.opacity = '';
      main.style.transform = '';
      if (window.gsap) window.gsap.set(main, { clearProps: 'all' });
    }

    // Make sure smooth scroll / body scroll are active again
    if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
    document.body.style.overflow = '';
  };

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resetTransitionState();
  });

  if (!gsap) return;

  // Check if browser supports native View Transitions API
  const supportsViewTransitions = 'startViewTransition' in document;

  // Exit transition handler (runs before navigating away)
  const handleExitTransition = (e, url) => {
    // Dynamically retrieve the page background color to ensure seamless transitions
    const bodyBgColor = window.getComputedStyle(document.body).backgroundColor || '#ffffff';

    // Create or select page transition overlay
    let overlay = document.querySelector('.theme-transition-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'theme-transition-overlay';
      Object.assign(overlay.style, {
        position: 'fixed',
        inset: '0',
        backgroundColor: bodyBgColor,
        zIndex: '99999',
        transform: 'translateY(100%)',
        pointerEvents: 'none'
      });
      document.body.appendChild(overlay);
    }

    e.preventDefault();

    // GSAP Swipe/Fade transition
    gsap.timeline({
      onComplete: () => {
        window.location.href = url;
      }
    })
    .to(overlay, {
      y: '0%',
      duration: 0.6,
      ease: 'power4.inOut'
    })
    .to('#MainContent', {
      opacity: 0,
      y: -30,
      duration: 0.4,
      ease: 'power2.in'
    }, 0);
  };

  // Bind exit transitions to eligible internal link clicks
  const initPageLinks = () => {
    // Skip if View Transitions are natively supported and active
    if (supportsViewTransitions && document.documentElement.classList.contains('view-transitions-enabled')) {
      return;
    }

    const currentDomain = window.location.hostname;

    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      
      // Filter out external, hash, javascript, file, and admin links
      if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('javascript:') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.includes('/admin') ||
        link.getAttribute('target') === '_blank'
      ) {
        return;
      }

      // Check if domain is internal
      try {
        const linkUrl = new URL(link.href, window.location.origin);
        if (linkUrl.hostname === currentDomain) {
          link.addEventListener('click', (e) => {
            // Check modifier keys to let default browser behavior handle new tab opens
            if (e.metaKey || e.ctrlKey || e.shiftKey) return;
            handleExitTransition(e, link.href);
          });
        }
      } catch (err) {
        // Handle relative URLs if URL constructor fails
        if (href.startsWith('/') || href.startsWith('./') || href.startsWith('../')) {
          link.addEventListener('click', (e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey) return;
            handleExitTransition(e, link.href);
          });
        }
      }
    });
  };

  // Entrance transition handler (runs on page load)
  const handleEntranceTransition = () => {
    // Page load fade-in animation
    gsap.fromTo('#MainContent', 
      { opacity: 0, y: 20 },
      { 
        opacity: 1, 
        y: 0, 
        duration: 0.8, 
        ease: 'power3.out',
        clearProps: 'all'
      }
    );
  };

  // Run animations
  initPageLinks();
  handleEntranceTransition();
  
  // Re-run bindings on shopify:section:load to support Theme Editor preview
  document.addEventListener('shopify:section:load', () => {
    initPageLinks();
  });
});
